import * as React from "react";
import { HudCurrency } from "../../inventory/currency/HudCurrency";
import { HudTopRightOptions } from "../../options/HudTopRightOptions";
export var BF2HudTopRight = function () { return (React.createElement("div", { className: "flex flex--row flex--top" },
    React.createElement(HudCurrency, null),
    React.createElement(HudTopRightOptions, null))); };



//////////////////
// WEBPACK FOOTER
// ./src/features/player-base/hud/BF2HudTopRight.tsx
// module id = 2311
// module chunks = 3